import React from "react";
import { useSelector } from "react-redux";

import { SpinnerLoader } from "../../../../../components/loaders";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import * as fileDownloadStore from "../../store/file-download.store";

import { FileDownloadButton } from "../file-download-button/file-download-button.component";
import { FileDownloadPlainText } from "../file-download-plaintext/file-download-plaintext.component";
import { FileDownloadSimpleButton } from "../file-download-simple-button/file-download-simple-button.component";
import { FileDownloadText } from "../file-download-text/file-download-text.component";

import { FileDownloadProps } from "./file-download.props";

export const FileDownload = withShowIf((props: FileDownloadProps) => {
  const { variant = "plainText" } = props;

  const onFileDownload = () => {
    if (props.disabled) {
      return;
    }

    fileDownloadStore.download(
      props.url,
      props.saveAsFileName,
      props.authRequired ?? false,
      props.accept
    );
  };

  const isTextVariant = () => variant === "text";
  const isPlainTextVariant = () => variant === "plainText";
  const isButtonVariant = () => variant === "button";
  const isSimpleButtonVariant = () => variant === "simple-button";

  return (
    <>
      <SpinnerLoader showIf={useSelector(fileDownloadStore.isFetching)} hasBackdrop={true} />

      <FileDownloadPlainText showIf={isPlainTextVariant()} onClick={onFileDownload}>
        {props.children}
      </FileDownloadPlainText>

      <FileDownloadText showIf={isTextVariant()} onClick={onFileDownload}>
        {props.children}
      </FileDownloadText>

      <FileDownloadButton showIf={isButtonVariant()} icon={props.icon} onDownload={onFileDownload}>
        {props.children}
      </FileDownloadButton>

      <FileDownloadSimpleButton
        showIf={isSimpleButtonVariant()}
        onClick={onFileDownload}
        size={props.size}
        startIcon={props.icon}
      >
        {props.children}
      </FileDownloadSimpleButton>
    </>
  );
});
